import { render, staticRenderFns } from "./CheckoutIdentification.html?vue&type=template&id=6761aec8&"
import script from "./CheckoutIdentification.ts?vue&type=script&lang=ts&"
export * from "./CheckoutIdentification.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports